import { render, staticRenderFns } from "./Func53Listagem.vue?vue&type=template&id=61e397ad"
import script from "./Func53Listagem.vue?vue&type=script&lang=js"
export * from "./Func53Listagem.vue?vue&type=script&lang=js"
import style0 from "./Func53Listagem.vue?vue&type=style&index=0&id=61e397ad&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports